"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateMasterLang = exports.getStateLang = void 0;
const stateMasterLangEn_1 = require("./stateMasterLangEn");
const stateLangEn_1 = require("./stateLangEn");
const stateLang_class_1 = __importDefault(require("./stateLang.class"));
const tranformPixelsToPt = (pixels) => parseFloat(pixels) * (72 / 96);
const getContent = (content) => (Object.assign(Object.assign({}, JSON.parse(JSON.stringify(content))), { fontSize: tranformPixelsToPt(content.fontSize) }));
function getStateLang(stateCode, countryCode = "USA") {
    const stateData = stateLangEn_1.allStates.find((aStateData) => aStateData.country === countryCode && aStateData.state === stateCode);
    if (stateData) {
        return new stateLang_class_1.default(stateData.country, stateData.state, stateData.variables, stateData.content ? getContent(stateData.content) : undefined, stateData.insuranceLicenseName, stateData.insuranceLicenseSignature);
    }
    return undefined;
}
exports.getStateLang = getStateLang;
function getStateMasterLang(stateCode, countryCode = "USA") {
    const stateData = stateMasterLangEn_1.allMasterStates.find((aStateData) => aStateData.country === countryCode && aStateData.state === stateCode);
    if (stateData) {
        const { country, state, variables, insuranceLicenseName, insuranceLicenseSignature } = stateData;
        return new stateLang_class_1.default(country, state, variables, stateData.content ? getContent(stateData.content) : undefined, insuranceLicenseName, insuranceLicenseSignature);
    }
    return undefined;
}
exports.getStateMasterLang = getStateMasterLang;
exports.default = stateLang_class_1.default;
//# sourceMappingURL=index.js.map